import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/woo-import")({
  component: lazyRouteComponent(() => import("./-pages/admin.woo-import")),
  head: () => ({
    meta: [
      { title: "WooCommerce Import · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
